export default __webpack_public_path__ + "static/media/lepri.ba97706f.webp";